var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import Button from '../Button';
const removeActiveClassName = (className) => {
    if (!className) {
        return className;
    }
    const classNamesArray = className.split(' ');
    const activeClassNameIndex = classNamesArray.indexOf('active');
    if (activeClassNameIndex === -1) {
        return className;
    }
    classNamesArray.splice(activeClassNameIndex, 1);
    return cn(classNamesArray);
};
export const Chip = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    // We removing `active` className to fix bug in chip dropdown where active className is added when dropdown is open
    // https://jira.weworkers.io/browse/DTR-106
    const chipClassName = removeActiveClassName(className);
    return React.createElement(Button, Object.assign({ circular: true, basic: true, className: chipClassName }, props));
};
Chip.displayName = 'Chip';
export default Chip;
//# sourceMappingURL=Chip.js.map